import React from 'react';

function Router() {
	return 'test';
}

export default Router;